import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { recentBuyers, images } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-37" data-mp="164eiug87bsnf">
      {open && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[360px]" data-id="element-38" data-mp="117628k2pbwoa">
          <div className="relative flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(11,27,58,0.35)]" data-id="element-39" data-mp="i93hihh6slwa">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-canvas object-contain" data-id="element-40" data-mp="s67txpl8d2zw" />
            <div className="min-w-0" data-id="element-41" data-mp="28jyb9y1d1nrh">
              <p className="text-sm font-bold leading-snug text-ink" data-id="element-42" data-mp="28iwmyrvc34rt">
                {buyer.name} <span aria-hidden="true" data-id="element-43" data-mp="23kbniunwop4f">{buyer.flag}</span>
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-44" data-mp="2ap2yx4lqeg8j">
                from {buyer.country} just bought <span className="font-semibold text-ink" data-id="element-45" data-mp="2fn4sijgs9xy9">Implant Case Decision™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-46" data-mp="2km7l34fkubpc">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-47" data-mp="2pmdlb8zwx6j1" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-48" data-mp="1rw8sx0635ygg">
              <XIcon className="h-4 w-4" data-id="element-49" data-mp="26oaow951c7b7" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}